import api from "../../utils/api";
import { React, useState } from "react";
import { toast } from "react-toastify";
import { ReactComponent as Loader } from "../../assets/loader.svg";
import { useNavigate } from "react-router-dom";
import { set } from "date-fns";

export default function ProfileTab({
  setActiveSection,
  logout,
  token,
  user,
  userLevel,
  setUserLevel,
  darkMode,
}) {
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [loadingOne, setLoadingOne] = useState(false);
  const [isDisabledOne, setIsDisabledOne] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  const handleChangePassword = async () => {
    setLoadingOne(true);
    setIsDisabledOne(true);
    try {
      const response = await api.post(
        `/email/forget-password?email=${user.email}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status !== 200) {
        toast.error("Error sending email to reset password");
      }
      toast.success("We have sent you an email to reset your password");
      setLoadingOne(false);
      setIsDisabledOne(false);
    } catch (error) {
      toast.error("Error sending email to reset password");
      setLoadingOne(false);
      setIsDisabledOne(false);
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const confirmCancel = () => {
    handleCancel(setLoading, setIsDisabled, token);
    closeModal();
  };

  return (
    <div className="">
      <section>
        <div
          className={`border shadow-lg p-6 rounded-lg ${
            darkMode
              ? "bg-gray-900 shadow-slate-200/10 border-gray-700 "
              : "bg-slate-100 border-gray-400 shadow-gray-500/10"
          }`}>
          <h3 className="pb-2 mb-4 text-2xl font-bold border-b border-gray-400">
            User Information
          </h3>
          <div className="space-y-2">
            <p>
              <span className="font-semibold">Email: </span>
              <span className="break-words">{user.email}</span>
            </p>

            <p>
              <span className="font-semibold">Current Password:</span> ********
            </p>
            <p>
              <span className="font-semibold">Plan Type:</span>{" "}
              {userLevel?.charAt(0).toUpperCase() +
                userLevel?.slice(1).toLowerCase()}
            </p>
          </div>
          <div className="flex flex-col mt-6 sm:flex-row sm:space-x-4">
            <button
              className="px-4 py-2 text-white transition-all bg-green-500 rounded shadow-lg hover:bg-green-600 sm:mt-0"
              disabled={isDisabledOne}
              onClick={handleChangePassword}>
              {loadingOne ? (
                <Loader
                  id="spinner"
                  className="w-6 h-6 mx-auto"
                />
              ) : (
                "Change Password"
              )}
            </button>
            <button
              onClick={openModal}
              disabled={isDisabled}
              className="px-4 py-2 mt-4 text-white transition-all bg-red-500 rounded shadow-lg hover:bg-red-600 sm:mt-0">
              {loading ? (
                <Loader
                  id="spinner"
                  className="w-6 h-6 mx-auto"
                />
              ) : (
                "Cancel Plan"
              )}
            </button>
          </div>
        </div>
      </section>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative w-full max-w-lg p-8 text-sm bg-white rounded-lg shadow-2xl">
            <button
              className="absolute text-gray-500 top-3 right-3 hover:text-gray-700"
              onClick={closeModal}
              aria-label="Close">
              &times;
            </button>

            <h2 className="mb-4 text-xl font-semibold text-gray-800">
              Cancel Subscription
            </h2>

            <p className="mb-4 text-gray-600">
              Your subscription will be cancelled at the end of your billing
              period on <strong>2024</strong>, and you will not be charged
              anymore.
            </p>

            <p className="mb-1 text-gray-600">
              After this date, you will lose access to:
            </p>
            <ul className="pl-5 mb-6 space-y-2 text-xs text-gray-700 list-disc">
              <li>Unlimited Tokens</li>
              <li>File Uploading</li>
              <li>Access to GPT-4</li>
            </ul>

            <div className="flex justify-end space-x-3">
              <button
                onClick={closeModal}
                className="px-5 py-2 text-gray-700 transition-all bg-gray-100 rounded-lg hover:bg-gray-200">
                Keep Subscription
              </button>

              <button
                onClick={confirmCancel}
                className="px-5 py-2 text-white transition-all bg-red-500 rounded-lg shadow-md hover:bg-red-600">
                Confirm Cancellation
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export const handleCancel = async (setLoading, setIsDisabled, token) => {
  setLoading(true);
  setIsDisabled(true);
  try {
    await api.post(
      `/payment/deactivate/subscription`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    toast.success("Subscription canceled successfully");

    setLoading(false);
    setIsDisabled(false);

    setTimeout(() => {
      window.location.href = "/app";
    }, 1500);
  } catch (error) {
    if (error.response?.status === 403) {
      toast.error(
        error.response?.data?.detail || "You are already on the free plan"
      );
    } else {
      toast.error(
        error.response?.data?.message || "Error canceling subscription"
      );
    }
    setLoading(false);
    setIsDisabled(false);
  }
};
